import { formatEuro } from '../../lib/format';

interface Props {
  caAnnuelCentimes: number;
  objectifCentimes: number;
  loading?: boolean;
}

export function KPIObjectifCard({
  caAnnuelCentimes,
  objectifCentimes,
  loading,
}: Props): JSX.Element {
  const pct = objectifCentimes > 0 ? Math.min(100, (caAnnuelCentimes * 100) / objectifCentimes) : 0;
  const reste = Math.max(0, objectifCentimes - caAnnuelCentimes);
  const pctTxt = `${pct.toFixed(1).replace('.', ',')} %`;
  const atteint = caAnnuelCentimes >= objectifCentimes;

  return (
    <div className="bg-slate-900/60 border border-slate-800 rounded-xl p-5 flex flex-col gap-3 col-span-1 sm:col-span-2">
      <div className="flex items-baseline justify-between">
        <div className="text-xs uppercase tracking-wider text-slate-500">
          Objectif annuel · {formatEuro(objectifCentimes)} HT
        </div>
        {loading === true ? (
          <div className="h-5 w-12 bg-slate-800 rounded animate-pulse" />
        ) : (
          <div
            className={`text-sm font-semibold ${atteint ? 'text-floryon-green' : 'text-slate-200'}`}
          >
            {pctTxt}
          </div>
        )}
      </div>
      <div className="h-3 bg-slate-800 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all ${atteint ? 'bg-floryon-green' : 'bg-emerald-600'}`}
          style={{ width: `${String(pct)}%` }}
        />
      </div>
      {loading === true ? (
        <div className="h-4 w-40 bg-slate-800 rounded animate-pulse" />
      ) : (
        <div className="text-[11px] text-slate-400">
          {atteint
            ? `Objectif dépassé · ${formatEuro(caAnnuelCentimes - objectifCentimes)} au-dessus`
            : `Encore ${formatEuro(reste)} à faire`}
        </div>
      )}
    </div>
  );
}
